import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const sponsors = [
    { 
      name: 'Method Marine', 
      url: 'https://www.facebook.com/Method.Marine.Supply/',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/2bgc54il_methodmarinelogo.jpeg'
    },
    { 
      name: 'OKBC', 
      url: 'https://www.okanaganbucktailco.ca/',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/5k6vznzo_obclgo.jpeg'
    },
    { 
      name: 'TNT Fishing Lures', 
      url: 'https://tntfishinglures.ca/?srsltid=AfmBOoquFEASwaG3zNywsjEi43VXme9Oc_cnHlVhb0gXwESP3S2DVVHMUser',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/cu8adubp_TNT_VICE_LOGO_20250820_104505_0000_220x%402x.webp'
    },
    { 
      name: 'Glow Tube', 
      url: 'https://glow-tube.com/',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/o8p6xbod_glowtubelogo.webp'
    },
    { 
      name: 'Hawaiian Malolo', 
      url: 'https://hawaiianmalolobirdteaser.com/',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/hk50e4wg_hawaiian-malolo-bird-teaser.png'
    },
    { 
      name: 'Big Fish Coffee', 
      url: 'https://www.bigfishcoffee.ca/',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/vq71ggkd_bigfish%20logo.png'
    },
    { 
      name: 'Mr.Sustainable', 
      url: 'https://www.facebook.com/mr.sustainable.2024',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/a8gtbkdq_471318547_122132698292553027_1965212609919330699_n.jpg'
    },
    { 
      name: 'Guide Choice Soft Plastics', 
      url: 'https://www.facebook.com/guides.choice.custom.soft.plastics',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/xf1tqi55_464909120_122093789534604319_3297184436210751907_n.jpg'
    },
    { 
      name: 'Kill Bill Art', 
      url: 'https://www.facebook.com/profile.php?id=61574822720032',
      logo: 'https://customer-assets.emergentagent.com/job_island-adventure-30/artifacts/uwnp3pjm_killbillartlogo.jpg'
    },
  ];

  return (
    <footer className="bg-gradient-to-r from-[#20B2AA] to-[#5DADE2] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Logo and Contact Section */}
          <div className="md:col-span-2">
            <div className="flex flex-col md:flex-row gap-6 items-start">
              <div className="flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/qruowtpm_strawberryislandlogopng.png"
                  alt="Strawberry Island Logo"
                  className="h-32 w-auto"
                  style={{ 
                    filter: 'brightness(0) invert(1)',
                    mixBlendMode: 'normal'
                  }}
                />
              </div>
              <div className="flex-1">
                <div className="mb-4">
                  <p className="text-sm mb-2 flex items-center gap-2">
                    <span>📍</span>
                    <span>4th St, Strawberry Island<br/>Tofino, BC V0R 2Z0</span>
                  </p>
                  <a
                    href="https://maps.google.com/?q=Strawberry+Island+Tofino+BC"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block hover:opacity-80 transition-opacity"
                  >
                    <img
                      src="https://maps.googleapis.com/maps/api/staticmap?center=Strawberry+Island,Tofino,BC&zoom=13&size=300x150&markers=color:red%7CStrawberry+Island,Tofino,BC&key=AIzaSyDummyKey"
                      alt="Map Location"
                      className="rounded-lg border-2 border-white/30 w-full max-w-xs"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </a>
                </div>
                <div className="space-y-2">
                  <a
                    href="mailto:joel@fishingtofino.net"
                    className="hover:text-[#FF69B4] transition-colors flex items-center gap-2"
                    data-testid="email-link"
                  >
                    <span>✉️</span>
                    <span>joel@fishingtofino.net</span>
                  </a>
                  <a
                    href="tel:+12503170600"
                    className="hover:text-[#FF69B4] transition-colors flex items-center gap-2"
                    data-testid="phone-link"
                  >
                    <span>📞</span>
                    <span>250-317-0600</span>
                  </a>
                </div>
                {/* Social Media Icons */}
                <div className="flex items-center space-x-4 mt-4">
                  <a
                    href="https://www.facebook.com/strawberryislandcharters"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-70 transition-opacity"
                    data-testid="footer-facebook-link"
                  >
                    <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                  <a
                    href="https://www.instagram.com/strawberry_island_charters/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-70 transition-opacity"
                    data-testid="footer-instagram-link"
                  >
                    <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links and Sponsors Combined */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 mb-6">
              <li>
                <Link to="/charters" className="hover:text-[#FF69B4] transition-colors">
                  Fishing Charters
                </Link>
              </li>
              <li>
                <Link to="/island-adventure" className="hover:text-[#FF69B4] transition-colors">
                  Island Tours & Adventures
                </Link>
              </li>
              <li>
                <Link to="/cabins" className="hover:text-[#FF69B4] transition-colors">
                  Cabin Bookings
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-[#FF69B4] transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-[#FF69B4] transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
            
            <h3 className="text-xl font-bold mb-4">Our Amazing Partners & Sponsors</h3>
            <div className="grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-9 gap-4">
              {sponsors.map((sponsor, index) => (
                <a
                  key={index}
                  href={sponsor.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white p-4 rounded-lg hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                  data-testid={`sponsor-${sponsor.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <img 
                    src={sponsor.logo} 
                    alt={sponsor.name}
                    className="w-full h-16 object-contain"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/30 mt-8 pt-6 text-center">
          <p className="text-sm opacity-90">
            © {new Date().getFullYear()} Strawberry Island. All rights reserved. 
            Made with 💖 in Tofino, BC
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;